import { __extends } from "tslib";
import { PartitionBase, EntityNode } from '@awayjs/view';
import { Graphics } from '@awayjs/graphics';
import { Timeline } from '../base/Timeline';
import { MouseEvent } from '../events/MouseEvent';
import { FrameScriptManager } from '../managers/FrameScriptManager';
import { Sprite } from './Sprite';
var MovieClip = /** @class */ (function (_super) {
    __extends(MovieClip, _super);
    function MovieClip(timeline) {
        if (timeline === void 0) { timeline = null; }
        var _this = _super.call(this) || this;
        _this.symbolID = 0;
        _this.preventScript = false;
        // buttonMode specifies if the mc has any mouse-listeners attached that should trigger showing the hand-cursor
        // if this is set once to true; it will never get set back to false again.
        _this._buttonMode = false;
        // isButton specifies if the mc-timeline is actually considered a button-timeline
        _this._isButton = false;
        _this._time = 0; // the current time inside the animation
        _this._currentFrameIndex = -1; // the current frame
        _this._isPlaying = true; // false if paused or stopped
        _this._isInit = true;
        _this._sessionID_childs = {};
        _this._sounds = {};
        _this._skipFramesForStream = 0;
        _this.buttonEnabled = true;
        /**
         *
         */
        _this.loop = true;
        /**
         * the current index of the current active frame
         */
        _this.constructedKeyFrameIndex = -1;
        _this._soundVolume = 1;
        _this._parentSoundVolume = 1;
        _this.doingSwap = false;
        _this._isButton = false;
        _this._buttonMode = false;
        _this._useHandCursor = true;
        _this.cursorType = 'pointer';
        //this.debugVisible=true;
        _this.inheritColorTransform = true;
        _this._onMouseOver = function (event) {
            if (_this.buttonEnabled)
                _this.currentFrameIndex = 1;
            else
                _this.currentFrameIndex = 0;
        };
        _this._onMouseOut = function (event) {
            _this.currentFrameIndex = 0;
        };
        _this._onMouseDown = function (event) {
            if (_this.buttonEnabled)
                _this.currentFrameIndex = 2;
            else
                _this.currentFrameIndex = 0;
        };
        _this._onMouseUp = function (event) {
            _this.currentFrameIndex = _this.currentFrameIndex == 0 ? 0 : 1;
        };
        _this._onDragOver = function (event) {
            if (_this.buttonEnabled)
                _this.currentFrameIndex = 2;
            else
                _this.currentFrameIndex = 0;
        };
        _this._onDragOut = function (event) {
            _this.currentFrameIndex = 1;
        };
        _this._timeline = timeline || new Timeline();
        return _this;
    }
    MovieClip.getNewMovieClip = function (timeline) {
        if (timeline === void 0) { timeline = null; }
        if (MovieClip._movieClips.length) {
            var movieClip = MovieClip._movieClips.pop();
            movieClip.timeline = timeline || new Timeline();
            movieClip.graphics = Graphics.getGraphics();
            return movieClip;
        }
        return new MovieClip(timeline);
    };
    MovieClip.clearPool = function () {
        MovieClip._movieClips = [];
    };
    MovieClip.prototype.initSoundStream = function (streamInfo, maxFrameNum) {
        if (!this._soundStreams) {
            this._soundStreams = new MovieClip.movieClipSoundsManagerClass(this);
        }
        this._soundStreams.initSoundStream(streamInfo, maxFrameNum);
    };
    MovieClip.prototype.addSoundStreamBlock = function (frameNum, streamBlock) {
        if (!this._soundStreams) {
            this._soundStreams = new MovieClip.movieClipSoundsManagerClass(this);
        }
        this._soundStreams.addSoundStreamBlock(frameNum, streamBlock);
    };
    MovieClip.prototype.stopCurrentStream = function (frameNum) {
        if (this._soundStreams) {
            //console.log("sync sounds for mc: ", this.numFrames);
            return this._soundStreams.stopStream(frameNum);
        }
    };
    MovieClip.prototype.resetStreamStopped = function () {
        if (this._soundStreams) {
            //console.log("sync sounds for mc: ", this.numFrames);
            this._soundStreams.resetStreamStopped();
        }
    };
    MovieClip.prototype._syncSounds = function (frameNum) {
        if (this._soundStreams) {
            //console.log("sync sounds for mc: ", this.numFrames);
            return this._soundStreams.syncSounds(frameNum, this._isPlaying, this.parent);
        }
        return 0;
    };
    MovieClip.prototype.startSound = function (id, sound, loopsToPlay) {
        if (this._sounds[id]) {
            this._sounds[id].stop();
        }
        sound.loopsToPlay = loopsToPlay;
        sound.play(0, false);
        this._sounds[id] = sound;
        if (!MovieClip._activeSounds[id])
            MovieClip._activeSounds[id] = [];
        MovieClip._activeSounds[id].push(sound);
    };
    MovieClip.prototype.stopSounds = function (soundID) {
        if (soundID === void 0) { soundID = null; }
        if (soundID) {
            if (this._sounds[soundID]) {
                this._sounds[soundID].stop();
                delete this._sounds[soundID];
            }
        }
        else {
            for (var key in this._sounds) {
                this._sounds[key].stop();
            }
            this._sounds = {};
        }
        var len = this._children.length;
        var child;
        for (var i = 0; i < len; ++i) {
            child = this._children[i];
            if (child.isAsset(MovieClip))
                child.stopSounds(soundID);
        }
        this.stopCurrentStream(this._currentFrameIndex);
        MovieClip._activeSounds = {};
        if (this._soundStreams) {
            this._soundStreams.syncSounds(0, false, this.parent);
        }
    };
    Object.defineProperty(MovieClip.prototype, "isPlaying", {
        get: function () {
            return this._isPlaying;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MovieClip.prototype, "soundVolume", {
        get: function () {
            return this._soundVolume;
        },
        set: function (value) {
            if (this._soundVolume == value) {
                return;
            }
            this._soundVolume = value;
            for (var key in this._sounds) {
                this._sounds[key].volume = value;
            }
            var len = this._children.length;
            var child;
            for (var i = 0; i < len; ++i) {
                child = this._children[i];
                if (child.isAsset(MovieClip))
                    child.soundVolume = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    MovieClip.prototype.stopSound = function (id) {
        if (this._sounds[id]) {
            this._sounds[id].stop();
            delete this._sounds[id];
        }
        if (MovieClip._activeSounds[id]) {
            for (var i = 0; i < MovieClip._activeSounds[id].length; i++) {
                MovieClip._activeSounds[id][i].stop();
            }
            delete MovieClip._activeSounds[id];
        }
    };
    MovieClip.prototype.buttonReset = function () {
        if (this._isButton && !this.buttonEnabled) {
            this.currentFrameIndex = 0;
        }
    };
    MovieClip.prototype.getMouseCursor = function () {
        if (this.name == 'scene')
            return 'initial';
        if (this._useHandCursor && this.buttonMode) {
            return this.cursorType;
        }
        return 'initial';
        /*
        var cursorName:string;
        var parent:DisplayObject=this.parent;
        while(parent){
            if(parent.isAsset(MovieClip)){
                cursorName=(<MovieClip>parent).getMouseCursor();
                if(cursorName!="initial"){
                    return cursorName;
                }
            }
            parent=parent.parent;
            if(parent && parent.name=="scene"){
                return "initial";
            }
        }
        return "initial";
        */
    };
    MovieClip.prototype.queueFrameScripts = function (timeline, frame_idx, scriptPass1) {
        console.warn('[MovieClip] - queueFrameScripts should only be called on AVM-Adapters');
    };
    MovieClip.prototype.registerScriptObject = function (child) {
        this[child.name] = child;
        if (child.isAsset(MovieClip))
            child.removeButtonListeners();
    };
    MovieClip.prototype.unregisterScriptObject = function (child) {
        delete this[child.name];
        if (child.isAsset(MovieClip))
            child.removeButtonListeners();
    };
    MovieClip.prototype.dispose = function () {
        this.disposeValues();
        MovieClip._movieClips.push(this);
    };
    MovieClip.prototype.disposeValues = function () {
        _super.prototype.disposeValues.call(this);
        this._sessionID_childs = {};
        this._timeline = null;
    };
    Object.defineProperty(MovieClip.prototype, "useHandCursor", {
        /* this was used for old Icycle-project text-translation
        public reset_textclones(): void {
            if (this.timeline) {
                //var len:number = this._potentialInstances.length;
                for (var key in this._potentialInstances) {
                    if (this._potentialInstances[key] != null) {
                        if (this._potentialInstances[key].isAsset(TextField)) {
                            (<TextField>this._potentialInstances[key]).text = (<TextField>this.timeline.getPotentialChildPrototype(parseInt(key))).text;
                        }
                        else if (this._potentialInstances[key].isAsset(MovieClip))
                            (<MovieClip>this._potentialInstances[key]).reset_textclones();
                    }
                }
            }
        }*/
        get: function () {
            return this._useHandCursor;
        },
        set: function (value) {
            this._useHandCursor = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MovieClip.prototype, "buttonMode", {
        get: function () {
            return this._buttonMode;
        },
        set: function (value) {
            this._buttonMode = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MovieClip.prototype, "isButton", {
        get: function () {
            return this._isButton;
        },
        set: function (value) {
            this._isButton = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MovieClip.prototype, "isInit", {
        get: function () {
            return this._isInit;
        },
        set: function (value) {
            this._isInit = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MovieClip.prototype, "timeline", {
        get: function () {
            return this._timeline;
        },
        set: function (value) {
            if (this._timeline == value)
                return;
            this._timeline = value;
            this.reset(false, false);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MovieClip.prototype, "numFrames", {
        get: function () {
            return this._timeline.numFrames;
        },
        enumerable: true,
        configurable: true
    });
    MovieClip.prototype.jumpToLabel = function (label, offset) {
        if (offset === void 0) { offset = 0; }
        // the timeline.jumpTolabel will set currentFrameIndex
        this._timeline.jumpToLabel(this, label, offset);
    };
    MovieClip.prototype.reset = function (fireScripts, resetSelf) {
        if (fireScripts === void 0) { fireScripts = true; }
        if (resetSelf === void 0) { resetSelf = true; }
        if (resetSelf)
            _super.prototype.reset.call(this);
        if (this.id == 4115)
            console.warn('reset', this.id);
        this.resetStreamStopped();
        // time only is relevant for the root mc, as it is the only one that executes the update function
        this._time = 0;
        //this.stopSounds();
        if (resetSelf && this._adapter)
            this.adapter.freeFromScript();
        this.constructedKeyFrameIndex = -1;
        for (var i = this.numChildren - 1; i >= 0; i--)
            this.removeChildAt(i);
        this.graphics.clear();
        if (fireScripts) {
            var numFrames = this._timeline.keyframe_indices.length;
            this._isPlaying = Boolean(numFrames > 1);
            if (numFrames) {
                this._currentFrameIndex = 0;
                // contruct the timeline and queue the script.
                //if(fireScripts){
                this._timeline.constructNextFrame(this, fireScripts && !this.doingSwap && !this.preventScript, true);
                //}
            }
            else {
                this._currentFrameIndex = -1;
            }
        }
        // prevents the playhead to get moved in the advance frame again:
        this._skipAdvance = true;
        //FrameScriptManager.execute_queue();
    };
    Object.defineProperty(MovieClip.prototype, "currentFrameIndex", {
        /*
        * Setting the currentFrameIndex will move the playhead for this movieclip to the new position
         */
        get: function () {
            return this._currentFrameIndex;
        },
        set: function (value) {
            var queue_script = true;
            var numFrames = this._timeline.keyframe_indices.length;
            this.resetStreamStopped();
            if (!numFrames)
                return;
            if (value < 0) {
                value = 0;
            }
            else if (value >= numFrames) {
                // if value is greater than the available number of
                // frames, the playhead is moved to the last frame in the timeline.
                // In this case the frame specified is not considered a keyframe,
                // no scripts should be executed in this case
                value = numFrames - 1;
                queue_script = false;
            }
            this._skipAdvance = false;
            if (this._currentFrameIndex == value)
                return;
            this._currentFrameIndex = value;
            //console.log("_currentFrameIndex ", this.name, this._currentFrameIndex);
            //changing current frame will ignore advance command for that
            //update's advanceFrame function, unless advanceFrame has
            //already been executed
            this._timeline.gotoFrame(this, value, queue_script, false, true);
        },
        enumerable: true,
        configurable: true
    });
    MovieClip.prototype.addButtonListeners = function () {
        this._isButton = true;
        this.stop();
        this.addEventListener(MouseEvent.MOUSE_OVER, this._onMouseOver);
        this.addEventListener(MouseEvent.MOUSE_OUT, this._onMouseOut);
        this.addEventListener(MouseEvent.MOUSE_DOWN, this._onMouseDown);
        this.addEventListener(MouseEvent.MOUSE_UP, this._onMouseUp);
        this.addEventListener(MouseEvent.DRAG_OVER, this._onDragOver);
        this.addEventListener(MouseEvent.DRAG_OUT, this._onDragOut);
        this.mouseChildren = false;
    };
    MovieClip.prototype.removeButtonListeners = function () {
        this.removeEventListener(MouseEvent.MOUSE_OVER, this._onMouseOver);
        this.removeEventListener(MouseEvent.MOUSE_OUT, this._onMouseOut);
        this.removeEventListener(MouseEvent.MOUSE_DOWN, this._onMouseDown);
        this.removeEventListener(MouseEvent.MOUSE_UP, this._onMouseUp);
        this.removeEventListener(MouseEvent.DRAG_OVER, this._onDragOver);
        this.removeEventListener(MouseEvent.DRAG_OUT, this._onDragOut);
    };
    MovieClip.prototype.swapChildrenAt = function (index1, index2) {
        console.warn('[scene/MovieClip] - swapChildrenAt - not implemented');
    };
    MovieClip.prototype.swapDepths = function (child, depth) {
        console.warn('[scene/MovieClip] - swapDepths - not implemented');
    };
    MovieClip.prototype.getTimelineChildAtSessionID = function (sessionID) {
        return this._sessionID_childs[sessionID];
    };
    // should only be called from timeline when navigating frames
    MovieClip.prototype.constructFrame = function (timeline, start_construct_idx, target_keyframe_idx, jump_forward, frame_idx, queue_pass2, queue_script) {
        console.warn('[scene/MovieClip] - constructFrame not implemented');
    };
    MovieClip.prototype.addTimelineChildAtDepth = function (child, depth, sessionID) {
        console.warn('[scene/MovieClip] - addTimelineChildAtDepth not implemented');
        return null;
    };
    MovieClip.prototype.removeTimelineChildAtDepth = function (depth) {
        console.warn('[scene/MovieClip] - removeTimelineChildAtDepth not implemented');
    };
    MovieClip.prototype.removeChildAtInternal = function (index) {
        var child = this._children[index];
        if (child._adapter)
            child.adapter.freeFromScript();
        this.adapter.unregisterScriptObject(child);
        delete this._sessionID_childs[child._sessionID];
        child._sessionID = -1;
        if (child.adapter && child.adapter.dispatchStaticEvent) {
            child.adapter.dispatchStaticEvent('removed', child.adapter);
        }
        if (this.isOnDisplayList() && child.adapter.dispatch_REMOVED_FROM_STAGE) {
            child.adapter.dispatch_REMOVED_FROM_STAGE(child);
        }
        return _super.prototype.removeChildAtInternal.call(this, index);
    };
    Object.defineProperty(MovieClip.prototype, "assetType", {
        get: function () {
            return MovieClip.assetType;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Starts playback of animation from current position
     */
    MovieClip.prototype.play = function () {
        if (this._timeline.keyframe_indices.length > 1)
            this._isPlaying = true;
    };
    /**
     * Stop playback of animation and hold current position
     */
    MovieClip.prototype.stop = function () {
        //this.stopSounds();
        this.resetStreamStopped();
        this._isPlaying = false;
    };
    MovieClip.prototype.clone = function () {
        var newInstance = MovieClip.getNewMovieClip(this._timeline);
        this.copyTo(newInstance);
        return newInstance;
    };
    MovieClip.prototype.copyTo = function (movieClip) {
        _super.prototype.copyTo.call(this, movieClip);
        movieClip.loop = this.loop;
        movieClip._soundStreams = this._soundStreams;
        movieClip.symbolID = this.symbolID;
    };
    MovieClip.prototype.advanceFrameInternal = function () {
        // if this._skipadvance is true, the mc has already been moving on its timeline this frame
        // this happens for objects that have been newly added to parent
        // they still need to queue their scripts
        //if(this._timeline && this._timeline.numFrames>0)
        if (this._timeline && this._timeline.numFrames > 0 && this._isPlaying && !this._skipAdvance) {
            if (this._currentFrameIndex == this._timeline.keyframe_indices.length - 1) {
                if (this.loop) {
                    // end of loop - jump to first frame.
                    if (this._currentFrameIndex == 0) {
                        // do nothing if we are already on frame 1
                    }
                    else {
                        this._currentFrameIndex = 0;
                        this.resetStreamStopped();
                        this._timeline.gotoFrame(this, 0, true, true, true);
                    }
                }
                else //end of timeline, stop playing
                    this._isPlaying = false;
            }
            else { // not end - construct next frame
                this._currentFrameIndex++;
                this._timeline.constructNextFrame(this);
            }
            //console.log("advancedFrame ", this.name, this._currentFrameIndex);
        }
        _super.prototype.advanceFrame.call(this);
        this._skipAdvance = false;
    };
    MovieClip.prototype.advanceFrame = function () {
        if (this._skipFramesForStream == 0) {
            this.advanceFrameInternal();
        }
        /*if(this._skipFramesForStream<0){
            console.log("wait for audio to catch up");
        }*/
        this._skipFramesForStream = this._syncSounds(this._currentFrameIndex);
        while (this._skipFramesForStream > 0) {
            //console.log("skip frame for keeping audio stream synced");
            FrameScriptManager.execute_queue();
            this.advanceFrameInternal();
            this._skipFramesForStream = this._syncSounds(this._currentFrameIndex);
        }
    };
    // DEBUG CODE:
    MovieClip.prototype.logHierarchy = function (depth) {
        if (depth === void 0) { depth = 0; }
        this.printHierarchyName(depth, this);
        var len = this._children.length;
        var child;
        for (var i = 0; i < len; i++) {
            child = this._children[i];
            if (child.isAsset(MovieClip))
                child.logHierarchy(depth + 1);
            else
                this.printHierarchyName(depth + 1, child);
        }
    };
    MovieClip.prototype.printHierarchyName = function (depth, target) {
        var str = '';
        for (var i = 0; i < depth; ++i)
            str += '--';
        str += ' ' + target.name + ' = ' + target.id;
        console.log(str);
    };
    MovieClip.prototype.clear = function () {
        //clear out potential instances
        this.resetStreamStopped();
        /* check memory disposal with new approach of child-instancing
        for (var key in this._potentialInstances) {
            var instance: IAsset = this._potentialInstances[key];

            //only dispose instances that are not used in script ie. do not have an instance name
            if (instance && !instance.name) {
                if (!instance.isAsset(Sprite)) {
                    FrameScriptManager.add_child_to_dispose(<DisplayObject>instance);

                }
                delete this._potentialInstances[key];
            }
        }
        */
        _super.prototype.clear.call(this);
    };
    //todo: this 3 are no longer used (?)
    MovieClip.avm1ScriptQueue = [];
    MovieClip.avm1ScriptQueueScripts = [];
    MovieClip.avm1LoadedActions = [];
    MovieClip.movieClipSoundsManagerClass = null;
    MovieClip._movieClips = new Array();
    MovieClip._activeSounds = {};
    MovieClip.assetType = '[asset MovieClip]';
    return MovieClip;
}(Sprite));
export { MovieClip };
PartitionBase.registerAbstraction(EntityNode, MovieClip);
